import { File } from '../files/files.model';
import { OfficeContact } from '../office-contacts/office-contacts.model';

export class Office {
    id?: string;
    title: any;
    [title: string]: any;
    file: File;
    office_contacts: Array<OfficeContact>;

    constructor(options: any) {
        this.id = options.id;
        this.title = options.title;
        this.file = options.file;
        this.office_contacts = options.office_contacts;
    }
}
